<template>
  <div>
    <!-- <YA_ScrollComponent :scrollHeight="55"> -->
      <PowerImitateMain ref="mainHeight" />

      <div>
        <PowerImitateContent />
      </div>

      <v-footer inset padless>
        <YA_footer />
      </v-footer>
    <!-- </YA_ScrollComponent> -->
  </div>
</template>

<script>
import YA_footer from '@/components/WebBar/YA_footer.vue';
import YA_ScrollComponent from '@/components/WebBar/YA_ScrollComponent.vue';
import PowerImitateMain from '@/components/PowerImitate/PowerImitateMain.vue';
import PowerImitateContent from '@/components/PowerImitate/PowerImitateContent.vue';

export default {
  
  name: 'PowerImitateView',
  components: {
    YA_footer,
    // YA_ScrollComponent,
    PowerImitateMain,
    PowerImitateContent,
  },
  data() {
    return {

    }
  },
  created() {
    this.$store.watch(
      (state) => state.powerImitateMsg.powerImitateMainHeight, () => {
        if (this.$store.getters.getpowerImitateMainHeight) {
          window.scrollTo({
            top: this.$refs.mainHeight.$el.clientHeight,
            behavior: 'smooth',
          });
          this.$store.commit('HandlepowerImitateMainHeight', false);
        }
      }, {
        deep: true
      }
    );
  },
  mounted() {

  },

  methods: {

  }

};
</script>

<style scoped>
</style>